// 인쇄 설정 화면이 그리는 목록. **조판 자체는 서버에 있다**(`api/echo/gs_grammar_paper.py`).
// 화면과 PDF 가 두 벌로 갈리면 반드시 어긋나므로, 여기에는 고를 수 있는 값의 이름만 둔다.
//
// 항목 이름과 배치는 모사이트(지인에듀) PDF 출력 설정 화면을 그대로 따랐다.
// 선생님이 거기서 쓰던 말 그대로여야 헷갈리지 않는다.

// 모사이트 색상 선택기에 미리 박혀 있는 다섯 색.
export const COLOR_DOT_LIST = [
  "#B95555",
  "#1F3864",
  "#EF8DBB",
  "#7BAE4B",
  "#5BAADE",
];

export const PRESET_LABEL = {
  xs: "매우 작음",
  sm: "작음",
  md: "보통",
  lg: "큼",
};

// 머리글 모양. 모사이트도 '기본' 과 '스타일n' 으로 부른다.
export const STYLE_LABEL = {
  0: "기본",
  1: "스타일1",
  2: "스타일2",
  3: "스타일3",
};
